import { RevisionAnnotation } from "types/RevisionAnnotation";

export const useIsAnnotationCommentLong = (annotation: RevisionAnnotation) => {
  if (annotation.forceInline) return false;

  var ops = annotation.commentObject;

  if (!ops) return false;

  const comment = useConvertQuillToPlaintext(ops);
  return comment.length > 62;
};
